import { render, staticRenderFns } from "./AgilityPage.vue?vue&type=template&id=3ae5a776&"
import script from "./AgilityPage.vue?vue&type=script&lang=js&"
export * from "./AgilityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports